// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__38_38","icon":"style_icon__1H8Ti","title":"style_title__1zYkR","logo":"style_logo__2QXqQ","logoContainer":"style_logoContainer__2BxcY"};